import type { ElementNode } from '../store/editor.store'

/**
 * Las fotos y su radio.
 *
 * Una foto redondeada sigue el radio de las tarjetas del estilo (ver
 * `applyMediaRadius` en el render) salvo que su `borderRadius` esté en
 * `overrides`, que es lo que anota cambiarlo a mano. Elegir un preset, un
 * estilo de diseño o un look de tarjeta es rediseñar el sitio: las fotos
 * vuelven al estilo, igual que las tarjetas.
 */

/** Una foto, o una caja que sólo enmarca fotos y las recorta con su radio. */
export function isMediaNode(node: Pick<ElementNode, 'type' | 'children'>): boolean {
  return node.type === 'image'
    || (node.type === 'div' && node.children.length > 0 && node.children.every((child) => child.type === 'image'))
}

/** El mismo nodo si no cambia nada, para no rehacer lo que no se tocó. */
export function releaseMediaRadiusOverrides(node: ElementNode): ElementNode {
  const children = node.children.map(releaseMediaRadiusOverrides)
  const childrenChanged = children.some((child, index) => child !== node.children[index])
  const overrides = node.styleRefs?.overrides
  const release = isMediaNode(node) && overrides?.includes('borderRadius')
  if (!release && !childrenChanged) return node
  let next: ElementNode = childrenChanged ? { ...node, children } : node
  if (release) {
    const rest = overrides!.filter((key) => key !== 'borderRadius')
    const { overrides: _dropped, ...refs } = node.styleRefs!
    next = { ...next, styleRefs: rest.length ? { ...refs, overrides: rest } : refs }
  }
  return next
}
